// SEQ-145: the frozen page-1 figures stored in claims_reports.claimed_set.summary.
// Pure module (no supabase import) so regeneration layout selection is testable
// under deno alongside the engine suites.

export interface Page1Summary {
  A?: number;
  B?: number;
  C?: number;
  cum_progress?: number;
  paid_variations_total?: number;
  retention_base?: number;
  // Amendment 2 (additive): deduction split + A's hire component. Presence of
  // the split fields switches regeneration to the three-row deduction layout.
  hire_billed_to_date?: number;
  retention_held_to_date?: number;
  b_receipts?: number;
  // Josh (27 Jul, additive): true retention-held-to-date basis (all prior
  // claims' retention, not paid-only) + the 5% ceiling, so an edited report
  // reproduces the "held to date vs ceiling" line. Absent on pre-fix reports.
  accumulated_retention?: number;
  retention_ceiling?: number;
  // SEQ-235: the project's ceiling percentage when the report was frozen.
  // Absent on older reports, which read as 5.
  retention_ceiling_percent?: number;
}

/**
 * Detect a new-format report (claimed_set.summary present) and return its
 * frozen top-down figures, or null for legacy reports. claimed_set is jsonb
 * (normally an object) but tolerate a raw JSON string just in case a caller
 * hands one over - mirrors ClaimEditModal's claimedSetHasSummary.
 */
export function extractPage1Summary(claimedSet: unknown): Page1Summary | null {
  let parsed: unknown = claimedSet;
  if (typeof parsed === "string") {
    try {
      parsed = JSON.parse(parsed);
    } catch {
      return null;
    }
  }
  if (!parsed || typeof parsed !== "object") return null;
  const summary = (parsed as Record<string, unknown>).summary;
  if (!summary || typeof summary !== "object") return null;
  return summary as Page1Summary;
}

/**
 * Amendment 2 dual-path: reports frozen BEFORE the deduction split carry no
 * b_receipts / retention_held_to_date and must keep regenerating with the
 * combined "previously certified" row. Never derive the split from an old
 * frozen B.
 */
export function hasDeductionSplit(summary: Page1Summary): boolean {
  return summary.b_receipts != null && summary.retention_held_to_date != null;
}
